module.exports = __webpack_public_path__ + "static/media/LightPackets.af53fe0f.logo";